import type { StatusIndicator } from "./types";

export const parseRefRange = (refRange: string): { min: number; max: number } | null => {
  const match = refRange.match(/^([\d.]+)[-–]([\d.]+)$/);
  if (!match || !match[1] || !match[2]) return null;
  return { min: parseFloat(match[1]), max: parseFloat(match[2]) };
};

export const parseRefRangeToNumbers = (refRange?: string): { refRangeMin: number; refRangeMax: number } | null => {
  if (!refRange) return null;
  const parsed = parseRefRange(refRange);
  if (!parsed) return null;
  return { refRangeMin: parsed.min, refRangeMax: parsed.max };
};

export const getStatusColor = (indicator?: StatusIndicator): string => {
  if (!indicator) return "text-gray-500";
  if (indicator === "H") return "text-orange-600";
  if (indicator === "L") return "text-blue-600";
  return "text-emerald-600";
};

export const getStatusVariant = (
  indicator?: StatusIndicator
): "lab-high" | "lab-low" | "lab-normal" | "lab-recorded" => {
  if (indicator === "H") return "lab-high";
  if (indicator === "L") return "lab-low";
  if (indicator === "N") return "lab-normal";
  return "lab-recorded";
};

export const getDotColor = (indicator?: StatusIndicator): string => {
  if (indicator === "H") return "bg-orange-400 dark:bg-orange-500";
  if (indicator === "L") return "bg-blue-400 dark:bg-blue-500";
  if (indicator === "N") return "bg-emerald-400 dark:bg-emerald-500";
  return "bg-gray-300 dark:bg-gray-600";
};

export const getBarColor = (statusIndicator?: string): string => {
  if (statusIndicator === "H") return "#fed7aa";
  if (statusIndicator === "L") return "#bfdbfe";
  if (statusIndicator === "N") return "#a7f3d0";
  return "#e5e7eb";
};
